export default __webpack_public_path__ + "static/media/user-arrow.6d5e9ae7.svg";